import React from 'react';
import './DashboardBanner.css';
import { useLanguage } from '../../../context/LanguageContext';
import { getTranslation } from '../../../i18n/translations';

const DashboardBanner = () => {
  const { language } = useLanguage();
  return (
    <div className="tbb-dashboard-banner">
      <div className="tbb-dashboard-banner__bg">
        <img src="/images/dashboard/banner-bg.webp" alt="banner" loading="lazy" />
      </div>
      <div className="tbb-dashboard-banner__bg-asic">
        <img src="/images/dashboard/asic-lg.webp" alt="asic" loading="lazy" />
      </div>
      <div className="tbb-dashboard-banner__bg-title-block">
        <p className="tbb-dashboard-banner__bg-title">{getTranslation('oneDayMining', language)}</p>
        <p className="tbb-dashboard-banner__bg-subtitle">{getTranslation('forFree', language)}</p>
      </div>
      <div className="tbb-dashboard-banner__content">
        <h1 className="tbb-dashboard-banner__title">{getTranslation('tryBestPerformance', language)}</h1>
        <p className="tbb-dashboard-banner__description">
          {getTranslation('getMiningExperience', language)}
        </p>
        <div className="tbb-dashboard-banner__btn-block">
          <button className="tbb-dashboard-banner__btn">{getTranslation('activate', language)}</button>
          <div className="tbb-dashboard-banner__power-block">
            <p className="tbb-dashboard-banner__power">234 TH/s</p>
            <p className="tbb-dashboard-banner__power-title">{getTranslation('miningPower', language)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardBanner;

